export const EMPTY_HISTORY_PNG =
  'https://static.rfstat.com/renderforest/images/logo_maker_images/ai_icon_empty_history.png'
export const VIDEO_MAKER_STATIC_ASSETS_PATH =
  'https://cdn.renderforest.com/video-maker/static-assets'
export const SEARCH_NO_RESULT_FOUND_IMG = `${VIDEO_MAKER_STATIC_ASSETS_PATH}/no-result-found-img.png`
export const DROPDOWN_NO_RESULTS_PNG = `https://s3.us-west-2.amazonaws.com/static.rfstat.com/renderforest/images/v2/video-editor-v2/dropdown-no-results.png`

export const AI_IMAGE_UNSAVED_CHANGES_PNG =
  'https://s3.us-west-2.amazonaws.com/static.rfstat.com/renderforest/images/media_changes.png'
export const TTS_LANGUAGE_MISMATCH_ERROR_IMG = `${VIDEO_MAKER_STATIC_ASSETS_PATH}/tts_mismatch_png_light.png`

export const CLOUD_OVERLOAD_PNG = `https://static.rfstat.com/renderforest/images/v2/video-editor-v2/cloud_overload_img.png`
